var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleWhiteSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8444 10.4332H19.2V10.4H12V13.6H16.5212C15.8616 15.4628 14.0892 16.8 12 16.8C9.3492 16.8 7.2 14.6508 7.2 12C7.2 9.3492 9.3492 7.2 12 7.2C13.2236 7.2 14.3368 7.6616 15.1844 8.4156L17.4472 6.1528C16.0184 4.8212 14.1072 4 12 4C7.582 4 4 7.582 4 12C4 16.418 7.582 20 12 20C16.418 20 20 16.418 20 12C20 11.4636 19.9448 10.94 19.8444 10.4332Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92285 8.2764L7.55125 10.204C8.26245 8.4432 9.98485 7.2 12.0005 7.2C13.2241 7.2 14.3373 7.6616 15.1849 8.4156L17.4477 6.1528C16.0189 4.8212 14.1077 4 12.0005 4C8.92765 4 6.26285 5.7348 4.92285 8.2764Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 20C14.0663 20 15.9439 19.2092 17.3635 17.9232L14.8875 15.828C14.0573 16.4593 13.0429 16.8008 11.9999 16.8C9.91913 16.8 8.15233 15.4732 7.48673 13.6216L4.87793 15.6316C6.20193 18.2224 8.89073 20 11.9999 20Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8444 10.4331H19.2V10.3999H12V13.5999H16.5212C16.2057 14.4865 15.6373 15.2612 14.8864 15.8283L14.8876 15.8275L17.3636 17.9227C17.1884 18.0819 20 15.9999 20 11.9999C20 11.4635 19.9448 10.9399 19.8444 10.4331Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleWhiteSmall);
export default __webpack_public_path__ + "static/media/googleWhiteSmall.ba9ab48bfadea810158be32793541385.svg";
export { ForwardRef as ReactComponent };